export const formatTruncatedString = ({ value, maxCharsPerSide = 4, }) => {
    if (value.length < maxCharsPerSide * 2 + 1)
        return value;
    return (value.substring(0, maxCharsPerSide) + '...' + value.substring(value.length - maxCharsPerSide));
};
export const formatAddress = ({ value }) => {
    const address = value.replace('0x', '');
    return '0x' + formatTruncatedString({ value: address, maxCharsPerSide: 4 });
};
export { getMenus } from './getMenus';
